import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { cleanHTML } from 'utils/dompurify';
import { makeStyles } from '@material-ui/styles';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import { EMAIL_DATE_FORMAT } from 'constants/config';
import moment from 'moment';
import Button from '../../buttons/Button';

const useStyles = makeStyles(() => ({
  prevMessage: {
    padding: '12px',
  },
  expandButton: {
    height: '1.5rem',
    maxWidth: '3rem !important',
    minWidth: '3rem !important',
    margin: '0 12px 15px 12px',
  },
}));


const PrevMessage = ({ message }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  if (!message) return null;
  if (!open) {
    return (
      <Button
        color="expandButton"
        variant="outlined"
        onClick={() => setOpen(true)}
        className={classes.expandButton}
      >
        <MoreHorizIcon />
      </Button>
    );
  }
  // EMAIL_DATE_FORMAT
  const receivedDate = moment(message.received_date)
    .local()
    .format(EMAIL_DATE_FORMAT);
  return (
    <div className={classes.prevMessage}>
      On {receivedDate}, {message.sent_from_name} &#60;{message.sent_from_email}&#62; wrote:
      {/* eslint-disable react/no-danger */}
      <div
        style={{
          margin: '0px 0px 0px 0.8ex',
          borderLeft: '1px solid rgb(204,204,204)',
          paddingLeft: '1ex',
        }}
        dangerouslySetInnerHTML={{ __html: cleanHTML(message.body_html) }}
      />
    </div>
  );
};

PrevMessage.propTypes = {
  message: PropTypes.shape({
    body_html: PropTypes.string,
  }),
};

PrevMessage.defaultProps = {
  message: null,
};

export default PrevMessage;
